/* ============================================
   CART TIMER - Reservation Countdown Engine
   ============================================ */
(function() {
  'use strict';

  var DURATION = 7 * 60;
  var URGENT_AT = 2 * 60;
  var CRITICAL_AT = 60;
  var LS_KEY = 'ct_start';
  var interval = null;
  var injecting = false;
  var debounceId = null;

  function getStartTime() {
    try {
      var v = localStorage.getItem(LS_KEY);
      return v ? parseInt(v, 10) : 0;
    } catch(e) { return 0; }
  }

  function setStartTime(t) {
    try { localStorage.setItem(LS_KEY, String(t)); } catch(e) {}
  }

  function clearStartTime() {
    try { localStorage.removeItem(LS_KEY); } catch(e) {}
  }

  function getRemaining() {
    var start = getStartTime();
    if (!start) return -1;
    var elapsed = Math.floor(Date.now() / 1000) - start;
    return Math.max(0, DURATION - elapsed);
  }

  function formatTime(secs) {
    var m = Math.floor(secs / 60);
    var s = secs % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  function updateDisplay() {
    var remaining = getRemaining();
    var timers = document.querySelectorAll('.ct-timer');
    if (timers.length === 0) return;

    for (var i = 0; i < timers.length; i++) {
      var el = timers[i];
      var countdown = el.querySelector('.ct-countdown');
      var textEl = el.querySelector('.ct-text');

      if (remaining < 0) {
        el.classList.remove('ct-active');
        continue;
      }

      el.classList.add('ct-active');
      el.classList.remove('ct-urgent', 'ct-critical', 'ct-expired');

      if (remaining === 0) {
        el.classList.add('ct-expired');
        countdown.textContent = '00:00';
        textEl.textContent = 'Your reserved cart time has expired';
        stopTimer();
        shakeCheckout();
      } else {
        countdown.textContent = formatTime(remaining);
        textEl.textContent = 'Hurry! Your cart is reserved for:';

        if (remaining <= CRITICAL_AT) {
          el.classList.add('ct-critical');
        } else if (remaining <= URGENT_AT) {
          el.classList.add('ct-urgent');
        }
      }
    }
  }

  function startTimer() {
    if (interval) return;
    updateDisplay();
    interval = setInterval(updateDisplay, 1000);
  }

  function stopTimer() {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
  }

  function onCartUpdate(hasItems) {
    if (!hasItems) {
      clearStartTime();
      stopTimer();
      var timers = document.querySelectorAll('.ct-timer');
      for (var i = 0; i < timers.length; i++) {
        timers[i].classList.remove('ct-active', 'ct-urgent', 'ct-critical', 'ct-expired');
      }
      return;
    }

    if (!getStartTime()) {
      setStartTime(Math.floor(Date.now() / 1000));
    }
    startTimer();
  }

  function checkCartState() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { onCartUpdate(cart.item_count > 0); })
      .catch(function() {});
  }

  var TIMER_HTML =
    '<div class="ct-timer">' +
      '<svg class="ct-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>' +
      '</svg>' +
      '<span class="ct-text">Hurry! Your cart is reserved for:</span>' +
      '<span class="ct-countdown">07:00</span>' +
      '<button class="ct-refresh">Refresh Timer</button>' +
    '</div>';

  function findCheckoutBtn() {
    var isProductPage = /\/products\//.test(window.location.pathname);
    var selectors = [
      '[name="checkout"]',
      'button[type="submit"][name="checkout"]',
      '.cart__checkout-button',
      '.cart-drawer__checkout',
      'a[href="/checkout"]',
      '[data-checkout-button]',
      '#checkout',
      '#CartDrawer-Checkout'
    ];
    if (!isProductPage) {
      selectors.push('.shopify-payment-button button');
    }
    return document.querySelector(selectors.join(', '));
  }

  function shakeCheckout() {
    var btn = findCheckoutBtn();
    if (!btn) return;
    btn.classList.remove('ct-checkout-shake');
    void btn.offsetHeight;
    btn.classList.add('ct-checkout-shake', 'ct-checkout-urgent');
  }

  function stopShakeCheckout() {
    var btn = findCheckoutBtn();
    if (!btn) return;
    btn.classList.remove('ct-checkout-shake', 'ct-checkout-urgent');
  }

  function refreshTimer() {
    stopTimer();
    stopShakeCheckout();
    setStartTime(Math.floor(Date.now() / 1000));
    startTimer();
  }

  function injectTimerHTML() {
    if (injecting) return;
    if (document.querySelector('.ct-timer')) return;
    injecting = true;

    var targets = [
      '.drawer__inner',
      '.cart-drawer__content',
      '.cart-drawer__inner',
      '.mini-cart__content',
      '.cart__contents',
      '.cart-items',
      'form[action="/cart"]'
    ];

    for (var i = 0; i < targets.length; i++) {
      var container = document.querySelector(targets[i]);
      if (container) {
        container.insertAdjacentHTML('afterbegin', TIMER_HTML);
        break;
      }
    }

    injecting = false;
  }

  function debouncedInject() {
    if (debounceId) return;
    debounceId = setTimeout(function() {
      debounceId = null;
      injectTimerHTML();
      if (getStartTime()) updateDisplay();
    }, 500);
  }

  function bindEvents() {
    /* Refresh timer button click */
    document.addEventListener('click', function(e) {
      if (e.target.closest('.ct-refresh')) {
        e.preventDefault();
        refreshTimer();
      }
    });

    /* Listen for Shopify section rendering events */
    document.addEventListener('shopify:section:load', debouncedInject);

    /* Watch for cart drawer opening — debounced, skip our own changes */
    var observer = new MutationObserver(function() {
      if (injecting) return;
      debouncedInject();
    });

    /* Only observe direct children of body for drawer opening */
    observer.observe(document.body, {
      childList: true,
      attributes: false,
      subtree: false
    });

    /* Listen for custom cart events common in themes */
    document.addEventListener('cart:updated', function() {
      setTimeout(function() { checkCartState(); debouncedInject(); }, 300);
    });

    /* Intercept fetch for AJAX cart — use event-based approach */
    var origFetch = window.fetch;
    if (origFetch) {
      window.fetch = function() {
        var url = arguments[0];
        var result = origFetch.apply(this, arguments);

        if (typeof url === 'string') {
          if (url.indexOf('/cart/add') !== -1) {
            result.then(function(response) {
              setTimeout(function() {
                onCartUpdate(true);
                debouncedInject();
              }, 500);
              return response;
            });
          } else if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/clear') !== -1) {
            result.then(function(response) {
              setTimeout(function() {
                checkCartState();
                debouncedInject();
              }, 500);
              return response;
            });
          }
        }
        return result;
      };
    }
  }

  function init() {
    injectTimerHTML();
    bindEvents();

    if (getStartTime()) {
      var remaining = getRemaining();
      if (remaining > 0) {
        startTimer();
      } else if (remaining === 0) {
        updateDisplay();
      } else {
        clearStartTime();
      }
    }

    checkCartState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
